import styled from 'styled-components';

export const TableContainer = styled.div`
    position: relative;
`;

export const FilterHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 1rem 0;
    border-top: 1px solid #E4E7EC;
`;

export const SearchWrapper = styled.div`
    margin-left: auto;
`;

export const PaginationWrapper = styled.div`
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
`;

